import { ReactNode } from 'react';
import { Card } from '../Card';

export interface DataCardEntry {
  label: string;
  entry: ReactNode;
}

export interface DataCardGroup {
  groupTitle: string;
  columnCount: number;
  groupData: DataCardEntry[];
}

export interface TabDataCardProps {
  title: string;
  loading: boolean;
  data: DataCardGroup[];
  size?: 'sm' | 'md';
  icon?: string;
  skeletonCount?: number;
}

export const TabDataCard = ({
  loading,
  data,
  title,
  skeletonCount,
  size = 'sm',
  icon,
}: TabDataCardProps) => {
  return (
    <Card title={title} size={size} skeletonCount={skeletonCount} icon={icon}>
      <div className="flex flex-col">
        {data.map((group: DataCardGroup) => {
          return (
            <div
              key={group.groupTitle}
              className="flex flex-col pb-5 mb-5 border-b border-grey-400 dark:border-grey-800 last-of-type:border-b-0"
            >
              <div className={`grid sm:grid-cols-${group.columnCount} py-4  sm:gap-10 gap-5 `}>
                {group.groupData.map((entry: DataCardEntry) => {
                  return (
                    <div className="flex flex-col" key={entry.label}>
                      <span className="mb-1 text-sm font-bold text-blue-800 dark:text-blue-500">
                        {entry.label}
                      </span>
                      <div>
                        {loading ? (
                          <div className="flex items-center mt-1 w-full animate-pulse">
                            <div className="w-full h-4 rounded bg-grey-400 dark:bg-grey-800"></div>
                          </div>
                        ) : (
                          <div className="break-all [&>a]:underline">{entry.entry}</div>
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
    </Card>
  );
};
